import { render, staticRenderFns } from "./TransactionRenewalHistory.vue?vue&type=template&id=4a1da6c6&"
import script from "./TransactionRenewalHistory.vue?vue&type=script&lang=js&"
export * from "./TransactionRenewalHistory.vue?vue&type=script&lang=js&"
import style0 from "./TransactionRenewalHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports